// extracted by mini-css-extract-plugin
export default {"about":"styles_about__SGcea","image":"styles_image__0kKw1","content":"styles_content__6gyQp","title":"styles_title__DwUQ4","btns":"styles_btns__EWG-R"};